<div *ngIf="iShowPayments">
  <div class="payment-list-toolbar" *ngIf="iTotalPaymentDetails?.length">
    <div class="payment-list-summary" *ngIf="iTotalPaymentDetails?.length">
      <span class="payment-summary-chip" *ngFor="let details of iTotalPaymentDetails">
        {{ formatPaymentMethod(details.paymentMethod) }} : {{ details.total }} €
      </span>
    </div>
  </div>
  <table class="table payment-table">
    <thead>
    <tr>
      <th scope="col" *ngIf="iShowInvoiceNumber" class="col-invoice">N°</th>
      <th scope="col" class="col-date">DATE</th>
      <th scope="col" class="col-montant">MONTANT</th>
      <th scope="col" *ngIf="!iNavMobile" class="col-mode">MODE</th>
      <th scope="col" *ngIf="iShowStudent" class="col-eleve">ELEVE</th>
      <th scope="col" *ngIf="!isDisabled && !iNavMobile && !iIsStudent" class="col-description">DESCRIPTION</th>
      <th scope="col" class="col-documents">DOCUMENTS</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let p of iPayments" [class.refund-row]="p.paymentType === 'REFUND'">
      <td *ngIf="iShowInvoiceNumber" class="col-invoice">{{formatInvoiceNumber(p.invoiceNumber)}}</td>
      <td class="col-date">{{p.date | date:'dd/MM/YYYY'}}</td>
      <td class="col-montant">{{p.amount}} €</td>
      <td *ngIf="!iNavMobile" class="col-mode">
        <div class="payment-mode-stack">
          <span class="payment-method-badge" [ngClass]="'payment-method-badge--' + getPaymentMethodVariant(p.paymentMethod)">
            {{ formatPaymentMethod(p.paymentMethod) }}
          </span>
          <span *ngIf="p.paymentType === 'REFUND'" class="payment-refund-badge">Remboursement</span>
        </div>
      </td>
      <td *ngIf="iShowStudent" class="col-eleve">{{p.studentName}}</td>
      <td *ngIf="!isDisabled && !iNavMobile && !iIsStudent" class="col-description">{{p.description}}</td>
      <td class="col-documents">
        <div class="payment-documents-actions">
          <button type="button"
                  class="btn btn-sm btn-outline-primary payment-document-btn"
                  *ngIf="canDownloadInvoice(p)"
                  (click)="uploadInvoice(p.paymentId)"
                  title="Télécharger la facture"
                  aria-label="Télécharger la facture">
            <i class="fa fa-file-pdf-o"></i>
            <span *ngIf="!iNavMobile">Facture</span>
          </button>

          <button type="button"
                  class="btn btn-sm btn-outline-secondary payment-document-btn"
                  *ngIf="canDownloadReceipt(p)"
                  (click)="uploadReceipt(p.paymentId)"
                  title="Télécharger le justificatif de paiement"
                  aria-label="Télécharger le justificatif de paiement">
            <i class="fa fa-download"></i>
            <span *ngIf="!iNavMobile">Justificatif</span>
          </button>

          <span class="payment-documents-empty" *ngIf="!canDownloadInvoice(p) && !canDownloadReceipt(p)">-</span>
        </div>
      </td>
    </tr>
    </tbody>
  </table>

  <app-pagination *ngIf="iPagePayment" [iEmpty]="iPagePayment.empty" [iFirst]="iPagePayment.first"
                  [iLast]="iPagePayment.last" [iNumber]="iPagePayment.number" [iTotalPages]="iPagePayment.totalPages"
                  [iPageSize]="iPagePayment.size"
                  (currentPageChanged)="onChangePaymentPage($event)">
  </app-pagination>
</div>
